import { render, staticRenderFns } from "./DataManagementDetail.vue?vue&type=template&id=26162c48&"
import script from "./DataManagementDetail.vue?vue&type=script&lang=js&"
export * from "./DataManagementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports